import { render, staticRenderFns } from "./VPasswordBreakdown.vue?vue&type=template&id=1bbf6abf&"
import script from "./VPasswordBreakdown.vue?vue&type=script&lang=ts&"
export * from "./VPasswordBreakdown.vue?vue&type=script&lang=ts&"
import style0 from "./VPasswordBreakdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports